export default __webpack_public_path__ + "static/media/tracking-green-bg.3f9eb81c.svg";